import _ from "lodash";
import {
  courseSchedulerFragment,
  slotFragment,
  unitPlanFragment,
} from "./SchedulerFragment";
import {
  getWeeklySchedulerQuery,
  getAssessmentDetailsCardQuery,
  getLeDetailsCardQuery,
  getYearlySchedulerQuery,
} from "./SchedulerQuery";
import client from "lib/apolloClient/client";

export const getLeCardDetailsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLeDetailsCardQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getAssessmentCardDetailsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentDetailsCardQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getYearlySchedulerFromCache = ({
  id,
  uids,
  endDate,
  startDate,
  isMYP = false,
  detailedUnitPlan = false,
  searchText,
  unitPlanTypes,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getYearlySchedulerQuery,
      variables: {
        id,
        uids,
        isMYP,
        endDate,
        startDate,
        detailedUnitPlan,
        searchText,
        unitPlanTypes,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeTimeSlotFragment = ({ id, data }) => {
  client.writeFragment({
    id: `WeeklySchedulerTimeSlot:${id}`,
    fragment: slotFragment.slot,
    fragmentName: "slotItem",
    data: data,
  });
};

export const getCourseWeeklySchedulerFromCache = ({
  id,
  startDate,
  endDate,
  curriculumProgramId,
  academicYearId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getWeeklySchedulerQuery,
      variables: {
        id,
        startDate,
        endDate,
        curriculumProgramId,
        academicYearId,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCourseWeeklySchedulerFragment = ({
  courseId,
  data,
  startDate,
  endDate,
  curriculumProgramId,
  academicYearId,
}) => {
  client.writeFragment({
    id: `Course:${courseId}`,
    fragment: courseSchedulerFragment.courseWeeklyScheduler,
    fragmentName: "courseItem",
    data: data,
    variables: {
      endDate: endDate,
      startDate: startDate,
      curriculumProgramId,
      academicYearId,
    },
  });
};

export const getUnitPlanItemFromCache = ({ id, uids = [] }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `UnitPlan:${id}`,
      fragment: unitPlanFragment.unitPlanDetail,
      fragmentName: "unitPlanItem",
      variables: {
        id,
        uids,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeUnitPlanItemToCache = ({ id, data, uids }) => {
  try {
    client.writeFragment({
      id: `UnitPlan:${id}`,
      fragment: unitPlanFragment.unitPlanDetail,
      fragmentName: "unitPlanItem",
      variables: {
        id,
        uids,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};
